export default "__VITE_ASSET__e6a799b5__"